import { CURRENCIES } from "../constants";

function Shimmer({ width = "100%", height = 20, radius = 6 }) {
  return (
    <div
      style={{
        width,
        height,
        borderRadius: radius,
        background: "linear-gradient(90deg,#1e1e2a 25%,#2a2a3a 50%,#1e1e2a 75%)",
        backgroundSize: "200% 100%",
        animation: "shimmer 1.4s infinite",
      }}
    />
  );
}

function getCurrencyItemState(cur, fxPrices, fxLoading, fxErrors) {
  const data = fxPrices[cur.id];
  const loading = fxLoading[cur.id];
  const error = fxErrors[cur.id];
  const isUp = data?.change >= 0;
  const highDp = cur.id === "jpy" || cur.id === "inr";
  return { data, loading, error, isUp, highDp, canPress: data && !loading && !error };
}

export function CurrencySwiper({ fxPrices, fxLoading, fxErrors, onPress }) {
  return (
    <div className="currency-section">
      <div className="section-label">
        CURRENCIES <span>vs USD</span>
      </div>
      <div className="swiper-wrap">
        <div className="swiper-fade" />
        <div className="swiper-track">
          {CURRENCIES.map((cur) => {
            const { data, loading, error, isUp, highDp, canPress } = getCurrencyItemState(
              cur,
              fxPrices,
              fxLoading,
              fxErrors
            );
            return (
              <div
                key={cur.id}
                onClick={() => canPress && onPress(cur, data)}
                className="cur-chip"
                style={{
                  border: `1px solid ${cur.accent}30`,
                  cursor: canPress ? "pointer" : "default",
                }}
                onMouseEnter={(e) => {
                  if (canPress) {
                    e.currentTarget.style.transform = "translateY(-3px)";
                    e.currentTarget.style.boxShadow = `0 8px 24px ${cur.accent}35`;
                  }
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "";
                  e.currentTarget.style.boxShadow = "";
                }}
              >
                <div className="glow" style={{ background: `${cur.accent}18` }} />
                <div className="cur-flag">{cur.flag}</div>
                <div className="cur-code">{cur.code}</div>
                <div className="cur-name">{cur.name}</div>
                {loading ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
                    <Shimmer height={13} radius={4} />
                    <Shimmer width="55%" height={10} radius={4} />
                  </div>
                ) : error ? (
                  <span className="err">⚠ Error</span>
                ) : data ? (
                  <>
                    <div className="cur-rate" style={{ color: cur.color }}>
                      {highDp ? data.rate.toFixed(2) : data.rate.toFixed(4)}
                    </div>
                    <div className={`cur-chg ${isUp ? "up" : "down"}`}>
                      {isUp ? "▲" : "▼"} {Math.abs(data.changePct)}%
                    </div>
                  </>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export function CurrencySidebar({ fxPrices, fxLoading, fxErrors, onPress }) {
  return (
    <aside className="sidebar">
      <div className="sidebar-label">CURRENCIES</div>
      {CURRENCIES.map((cur) => {
        const { data, loading, error, isUp, highDp, canPress } = getCurrencyItemState(
          cur,
          fxPrices,
          fxLoading,
          fxErrors
        );
        return (
          <div
            key={cur.id}
            onClick={() => canPress && onPress(cur, data)}
            className="sidebar-chip"
            style={{
              borderLeftColor: canPress ? cur.accent : "transparent",
              cursor: canPress ? "pointer" : "default",
            }}
          >
            <div className="cur-flag">{cur.flag}</div>
            <div className="cur-code">{cur.code}</div>
            <div className="cur-name">{cur.name}</div>
            {loading ? (
              <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                <Shimmer height={12} radius={4} />
                <Shimmer width="70%" height={8} radius={4} />
              </div>
            ) : error ? (
              <span className="err">⚠ Error! Please Refresh</span>
            ) : data ? (
              <>
                <div className="cur-rate" style={{ color: cur.color }}>
                  {highDp ? data.rate.toFixed(2) : data.rate.toFixed(4)}
                </div>
                <div className={`cur-chg ${isUp ? "up" : "down"}`}>
                  {isUp ? "▲" : "▼"} {Math.abs(data.changePct)}%
                </div>
              </>
            ) : null}
          </div>
        );
      })}
    </aside>
  );
}
